import { Grid, useElementBreakpoints } from "@compass/core";
import { FilePanel } from "components";
import { Permission, StaffServiceFile, UploadFile } from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { initDataModel } from "utils";
import { ServiceFile } from "./ServiceFile";

export const ServiceFiles = (props: {
  rootPermission: Permission;
  id: number;
  serviceFiles: StaffServiceFile[];
  setServiceFiles: (value: StaffServiceFile[]) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      {props.serviceFiles.map((serviceFile, index) => (
        <Grid key={index} item xs={smallFieldBreakpoints}>
          <ServiceFile
            rootPermission={props.rootPermission}
            serviceFile={serviceFile}
            setServiceFile={(serviceFile) =>
              props.setServiceFiles(
                produce(props.serviceFiles, (draft) => {
                  draft[index] = serviceFile;
                })
              )
            }
            cancelCreate={() => {
              props.setServiceFiles(
                produce(props.serviceFiles, (draft) => {
                  draft.splice(index, 1);
                })
              );
            }}
          />
        </Grid>
      ))}

      <Grid item xs={smallFieldBreakpoints}>
        <FilePanel
          onFileChange={(fileName, fileSize, uploadingData) => {
            const newServiceFile = initDataModel<StaffServiceFile>({
              uploadFile: initDataModel<UploadFile>({
                fileName: fileName,
                fileSize: fileSize,
                uploadingData: uploadingData,
              }),
            });

            props.setServiceFiles(
              produce(props.serviceFiles, (draft) => {
                draft.push(newServiceFile);
              })
            );
          }}
        />
      </Grid>
    </Grid>
  );
};
